import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { VisualOnlyLabel } from '../Label';

export default class Fieldset extends React.PureComponent {
    static propTypes = {
        /** Contents of the fieldset */
        children: PropTypes.node.isRequired,

        /** Label spoken to screen readers. */
        label: PropTypes.node.isRequired,

        /** Id given to outer container and to link group and error message */
        id: PropTypes.string.isRequired,

        /** Makes a visual-only label with the contents of label */
        isLabelVisible: PropTypes.bool,

        /** Indicates that the group is required */
        isRequired: PropTypes.bool,

        /** Marks the group as invalid */
        isInvalid: PropTypes.bool,

        /** The text to display as the invalid error message */
        errorText: PropTypes.string,

        /** Optional class name added to outer container */
        className: PropTypes.string
    };

    static defaultProps = {
        isLabelVisible: false
    };

    render() {
        const {
            children,
            label,
            id,
            isLabelVisible,
            isRequired,
            isInvalid,
            errorText,
            className,
            ...rest
        } = this.props;

        let srLabel = isRequired ? `${label} (Required)` : label;

        if (isInvalid) {
            srLabel += ' (Invalid)';
        }

        return (
            <div
                data-component="Fieldset"
                className={cx('sarsa-fieldset', className)}
                role="group"
                aria-label={srLabel}
                aria-describedby={errorText ? `${id}-error` : null}
                {...rest}>

                {isLabelVisible && (
                    <VisualOnlyLabel isRequired={isRequired}>
                        {label}
                    </VisualOnlyLabel>
                )}

                <div
                    id={id}
                    tabIndex="-1"
                    className={cx('sarsa-fieldset-children', {
                        'is-invalid': isInvalid,
                        'has-top-margin': isLabelVisible || errorText
                    })}>
                    {children}
                </div>

                {errorText && (
                    <div
                        id={`${id}-error`}
                        className="sarsa-field-error-message">
                        <span className="req" aria-hidden="true">*</span>
                        {errorText}
                    </div>
                )}
            </div>
        );
    }
}